export default __webpack_public_path__ + "static/media/users.06fd82ac.svg";